import { TopicGroup } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/types';
import { useMainEntity } from 'src/utils/Hooks/reduxSelectors';

/**
 * Simple hook that returns the taxonomy options for a topic group
 */
export const useTopicTaxonomyOptions = () => {
  const mainEntity = useMainEntity() as unknown as TopicGroup;
  const includedCategoryIds = mainEntity?.includedCategoryIds || [];
  const includedSubCategoryIds = mainEntity?.includedSubCategoryIds || [];
  const excludedCategoryIds = mainEntity?.excludedCategoryIds || [];
  const excludedSubCategoryIds = mainEntity?.excludedSubCategoryIds || [];

  return {
    includedCategoryIds,
    includedSubCategoryIds,
    excludedCategoryIds,
    excludedSubCategoryIds
  };
};
